
import React, { Suspense } from 'react'
import Banner from "../components/Banner";
import { lazy } from 'react';

const Faq = lazy(() => import("../components/Faq.jsx"));
const Solutions = lazy(() => import("../components/Solutions.jsx"));
const Investment = lazy(() => import("../components/Investment.jsx"));
const Footer = lazy(() => import("../components/Footer.jsx"));

function Homepage() {
  return (
    <>
      <Suspense fallback={<>Loading...</>}>
        <Banner />
        <Solutions />
        <Investment />
        <Faq />
        <Footer />
      </Suspense>

    </>
  );
}

export default Homepage;
